import { render } from "./Staff.vue?vue&type=template&id=e8a78484&scoped=true"
import script from "./Staff.vue?vue&type=script&lang=js"
export * from "./Staff.vue?vue&type=script&lang=js"

import "./Staff.vue?vue&type=style&index=0&id=e8a78484&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-e8a78484"

export default script